"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const angular2_modal_1 = require("angular2-modal");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
//INTERNAL LIBRARY BITS
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const support_modal_component_1 = require("./support-modal.component");
//VARIABLE MODELS
const user_1 = require("./user");
let UserService = class UserService {
    constructor(_permission, _http, _talk, _title, modal) {
        this._permission = _permission;
        this._http = _http;
        this._talk = _talk;
        this._title = _title;
        this.modal = modal;
        //initializations
        this.userURL = "/auth/who";
        this.usersURL = '/user';
    }
    set(val, setPreferences = false) {
        this.user = new user_1.User(val);
        return this._permission.set(this.user.permissions, setPreferences);
    }
    pull(restart = false) {
        return this._http.get(this.userURL)
            .toPromise()
            .then(response => {
            let data = JSON.parse(response._body);
            if (data.reports && Array.isArray(data.reports))
                data.reports = data.reports.filter(r => !r.defaultReport);
            return this.set(data);
        })
            .catch(this._talk.handle);
    }
    get() {
        return this.user || new user_1.User;
    }
    getWithOrgIndexes() {
        let tempUser = this.get();
        for (let o in tempUser.organization.roles) {
            tempUser.organization[o] = tempUser.organization[o].id;
        }
        return tempUser;
    }
    getReports() {
        return this.user.reports;
    }
    zendeskSupport(redirectIds) {
        // Login to zendesk to get the tokenized redirect url
        let logingUrl = '/zendesk/login';
        if (redirectIds)
            logingUrl += `?redirectIds=${redirectIds.join(",")}`;
        return this._http.post(logingUrl)
            .toPromise()
            .then(response => response.json());
    }
    askForSupport() {
        this.modal
            .open(support_modal_component_1.SupportModalComponent, (0, angular2_modal_1.overlayConfigFactory)({ isBlocking: true }))
            .then(dialogRef => {
            dialogRef.result.then((userInput) => {
                if (userInput) {
                    this._http.post('email/support', {
                        "user": this.user.email,
                        "url": this._title.getTitle(),
                        "subject": "Support Question From " + this.user.email,
                        "issue": userInput
                    })
                        .toPromise()
                        .then(this._talk.broadcast('Thank you, we will get back to you shortly'))
                        .catch(err => {
                        this._talk.broadcast('There was an error submitting your help request.');
                        console.error(err);
                    });
                }
            });
        });
    }
    //User Settings
    setUserTab(tab) {
        this.userTab = tab;
    }
    getUserTab() {
        return this.userTab;
    }
    generatePassword() {
        var lettersLC = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        var lettersUC = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        var symbols = ['!', '@', '$', '%', '&', '*'];
        var randomstring = [];
        for (var i = 0; i < 5; i++) {
            var rletLC = Math.floor(Math.random() * lettersLC.length);
            randomstring.push(lettersLC[rletLC]);
        }
        for (var i = 0; i < 3; i++) {
            var rnum = Math.floor(Math.random() * numbers.length);
            randomstring.push(numbers[rnum]);
        }
        for (var i = 0; i < 3; i++) {
            var rsym = Math.floor(Math.random() * symbols.length);
            randomstring.push(symbols[rsym]);
        }
        for (var i = 0; i < 3; i++) {
            var rletUC = Math.floor(Math.random() * lettersUC.length);
            randomstring.push(lettersUC[rletUC]);
        }
        for (var i = randomstring.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = randomstring[i];
            randomstring[i] = randomstring[j];
            randomstring[j] = temp;
        }
        return randomstring.join('');
    }
    updateTimezone(zone) {
        return this._http.patch(`${this.usersURL}/${this.user.id}`, { timezone: zone.time, tzCountry: zone.country })
            .toPromise()
            .then(res => {
            let json = res.json();
            //Update local user references as well, other services get latest update;
            this.user.timezone = json.timezone;
            this.user.tzCountry = json.tzCountry;
            return json;
        })
            .catch(err => err);
    }
    getTimezone() {
        return { time: this.user.timezone, country: this.user.tzCountry || null };
    }
    getTimezoneModifier() {
        return this.user.timezone ? Number(this.user.timezone.substr(0, this.user.timezone.indexOf(':'))) : 0;
    }
    changeEmail(newEmail) {
        return this._http.patch(`${this.usersURL}/${this.user.id}`, { email: newEmail })
            .toPromise()
            .then(res => {
            return res.json();
        })
            .catch(err => err);
    }
};
exports.UserService = UserService;
exports.UserService = UserService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [permission_service_1.PermissionService,
        token_service_1.TokenService,
        notification_service_1.NotificationService,
        platform_browser_1.Title,
        bootstrap_1.Modal])
], UserService);
//# sourceMappingURL=user.service.js.map